<template>
  <div>
    <!-- 商品类型管理 -->
    <el-card>
      <el-row class="title-biaoti">靓号商品类型管理</el-row>
      <el-row class="search">
        <el-select
          v-model="typeSearch.channel"
          placeholder="请选择渠道"
          clearable
          filterable
          style="width: 150px"
        >
          <el-option
            v-for="item in channelList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="queryType" :loading="typeLoading">
          查询
        </el-button>
        <el-button type="success" @click="operateType(1)"> 新增</el-button>
        <el-button type="warning" @click="resetTypeSearch"> 重置</el-button>
      </el-row>
      <el-row>
        <el-table
          height="65vh"
          :data="typeList"
          style="width: 100%"
          v-loading="typeLoading"
          border
        >
          <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
          <el-table-column prop="type" label="类型" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.type === 0 ? '纯数字' : scope.row.type === 1 ? '字母+数字' : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称" align="center"></el-table-column>
          <el-table-column prop="showId" label="展示号码" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.showId || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="newStatus" label="New标签" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.newStatus === 1 ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="sortOrder" label="排序" align="center" width="80"></el-table-column>
          <el-table-column prop="svipLevel" label="SVIP等级" align="center" width="100"></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="operateType(2, scope.row)"
              >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-card>

    <!-- 商品配置管理 -->
    <el-card class="card">
      <el-row class="title-biaoti">靓号商品配置管理</el-row>
      <el-row class="search">
        <el-select
          v-model="configSearch.typeId"
          placeholder="请选择类型"
          clearable
          filterable
          style="width: 150px"
        >
          <el-option
            v-for="type in typeList"
            :key="type.id"
            :label="type.name"
            :value="type.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="configSearch.idLength"
          placeholder="请选择位数"
          clearable
          style="width: 120px"
        >
          <el-option label="5位" :value="5"></el-option>
          <el-option label="6位" :value="6"></el-option>
          <el-option label="7位" :value="7"></el-option>
        </el-select>
        <el-select
          v-model="configSearch.valid"
          placeholder="请选择有效性"
          clearable
          style="width: 120px"
        >
          <el-option label="有效" :value="1"></el-option>
          <el-option label="无效" :value="0"></el-option>
        </el-select>
        <el-button type="primary" @click="queryConfig" :loading="configLoading">
          查询
        </el-button>
        <el-button type="success" @click="operateConfig(1)"> 新增</el-button>
        <el-button type="warning" @click="resetConfigSearch"> 重置</el-button>
      </el-row>
      <el-row>
        <el-table
          height="65vh"
          :data="configList"
          style="width: 100%"
          v-loading="configLoading"
          border
        >
          <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
          <el-table-column prop="typeId" label="类型ID" align="center" width="100"></el-table-column>
          <el-table-column prop="idLength" label="位数" align="center" width="80"></el-table-column>
          <el-table-column label="规格" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.specificationObjList && scope.row.specificationObjList.length > 0">
                <div
                  v-for="(spec, index) in scope.row.specificationObjList"
                  :key="index"
                  style="margin-bottom: 4px"
                >
                  {{ spec.points || 0 }}积分 / {{ spec.days || 0 }}天
                </div>
              </div>
              <div v-else-if="scope.row.specification" style="white-space: pre-wrap;">{{ parseSpecification(scope.row.specification) }}</div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="valid" label="有效性" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.valid === 1 ? '有效' : '无效' }}
            </template>
          </el-table-column>
          <el-table-column prop="ctime" label="创建时间" align="center" width="160">
            <template slot-scope="scope">
              {{ formatTime(scope.row.ctime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="operateConfig(2, scope.row)"
              >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <el-pagination
          :current-page.sync="configPageInfo.page"
          layout="total, prev, pager, next"
          background
          @current-change="handleConfigPageChange"
          :total="configPageInfo.total"
          class="pagination"
          :page-size="configPageInfo.pageSize"
        ></el-pagination>
      </el-row>
    </el-card>

    <!-- 类型管理弹窗 -->
    <el-dialog
      :title="typeDialogType === 1 ? '新增商品类型' : '编辑商品类型'"
      :visible.sync="typeDialogVisible"
      width="50%"
      :before-close="handleTypeDialogClose"
    >
      <div class="item">
        <span>类型</span>
        <el-select v-model="typeForm.type" placeholder="请选择类型" style="width: 200px">
          <el-option label="纯数字" :value="0"></el-option>
          <el-option label="字母+数字" :value="1"></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>名称</span>
        <el-input v-model="typeForm.name" placeholder="请输入名称"></el-input>
      </div>
      <div class="item">
        <span>展示号码</span>
        <el-input
          v-model="typeForm.showId"
          placeholder="请输入展示号码"
          type="textarea"
          :rows="2"
        ></el-input>
      </div>
      <div class="item">
        <span>New标签</span>
        <el-switch
          v-model="typeForm.newStatus"
          active-text="是"
          inactive-text="否"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </div>
      <div class="item">
        <span>排序权重</span>
        <el-input-number v-model="typeForm.sortOrder" :min="0" style="width: 200px"></el-input-number>
      </div>
      <div class="item">
        <span>状态</span>
        <el-switch
          v-model="typeForm.displayStatus"
          active-text="上架"
          inactive-text="下架"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </div>
      <div class="item">
        <span>SVIP等级</span>
        <el-input-number
          v-model="typeForm.svipLevel"
          :min="1"
          :max="10"
          style="width: 200px"
        ></el-input-number>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="submitTypeForm"
          v-loading="submitTypeLoading"
          type="primary"
        >
          {{ typeDialogType === 1 ? '新增' : '编辑' }}
        </el-button>
        <el-button @click="handleTypeDialogClose">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 商品配置弹窗 -->
    <el-dialog
      :title="configDialogType === 1 ? '新增商品配置' : '编辑商品配置'"
      :visible.sync="configDialogVisible"
      width="50%"
      :before-close="handleConfigDialogClose"
    >
      <div class="item">
        <span>类型</span>
        <el-select v-model="configForm.typeId" placeholder="请选择类型" filterable style="width: 200px">
          <el-option
            v-for="type in typeList"
            :key="type.id"
            :label="type.name"
            :value="type.id"
          ></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>位数</span>
        <el-input-number
          v-model="configForm.idLength"
          :min="5"
          :max="7"
          style="width: 200px"
        ></el-input-number>
      </div>
      <div class="item">
        <span>有效性</span>
        <el-switch
          v-model="configForm.valid"
          active-text="有效"
          inactive-text="无效"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </div>
      <div class="item" style="align-items: flex-start">
        <span>规格配置</span>
        <div style="margin-left: 10px">
          <div class="spec-item" v-for="(spec, index) in configForm.specificationObjList" :key="index">
            <el-input-number
              v-model="spec.points"
              placeholder="积分"
              :min="0"
              :max="999999"
              size="small"
            ></el-input-number>
            <span class="spec-label">积分</span>
            <span class="spec-divider">/</span>
            <el-input-number
              v-model="spec.days"
              placeholder="天数"
              :min="0"
              :max="9999"
              size="small"
            ></el-input-number>
            <span class="spec-label">天</span>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="removeSpec(index)"
              circle
              style="margin-left: 8px"
            ></el-button>
          </div>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addSpec">
            添加规格
          </el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="submitConfigForm"
          v-loading="submitConfigLoading"
          type="primary"
        >
          {{ configDialogType === 1 ? '新增' : '编辑' }}
        </el-button>
        <el-button @click="handleConfigDialogClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { allChannelList } from '@/utils/normalApi.js'

export default {
  data() {
    return {
      // 类型管理
      channelList: [],
      typeLoading: false,
      typeList: [],
      typeSearch: {
        channel: null
      },
      typeDialogVisible: false,
      typeDialogType: 1, // 1-新增 2-编辑
      submitTypeLoading: false,
      typeForm: {
        id: '',
        type: 0,
        name: '',
        showId: '',
        newStatus: 0,
        sortOrder: 0,
        displayStatus: 1,
        svipLevel: 0
      },

      // 商品配置管理
      configLoading: false,
      configList: [],
      configSearch: {
        typeId: 1,
        idLength: null,
        valid: null
      },
      configPageInfo: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      configDialogVisible: false,
      configDialogType: 1, // 1-新增 2-编辑
      submitConfigLoading: false,
      configForm: {
        id: '',
        typeId: null,
        idLength: 5,
        valid: 1,
        specificationObjList: [{ points: 0, days: 0 }]
      }
    }
  },
  async created() {
    this.channelList = await allChannelList()
    await this.queryType()
    await this.queryConfig()
  },
  methods: {
    // 格式化时间
    formatTime(timestamp) {
      if (!timestamp) return '-'
      const milliseconds = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
      return new Date(milliseconds).toLocaleString()
    },
    
    // 解析规格字符串
    parseSpecification(specification) {
      if (!specification) return '-'
      try {
        const specArray = typeof specification === 'string' ? JSON.parse(specification) : specification
        if (Array.isArray(specArray)) {
          return specArray.map(spec => `${spec.points || 0}积分 / ${spec.days || 0}天`).join('\n')
        }
        return '-'
      } catch (e) {
        return specification
      }
    },

    // ============ 类型管理相关方法 ============
    async queryType() {
      this.typeLoading = true
      // 构建查询参数，只包含 API 支持的参数
      const params = {}
      if (this.typeSearch.channel !== null && this.typeSearch.channel !== '') {
        params.channel = this.typeSearch.channel
      }
      
      const { data: res } = await this.$axios.get(
        this.$store.getters.path.premium_id_type_list +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        {
          params
        }
      )
      this.typeLoading = false
      if (res.code !== 0) return this.$message.error(res.msg)
      
      this.typeList = res.data || []
    },
    resetTypeSearch() {
      this.typeSearch = { channel: null }
      this.queryType()
    },
    operateType(type, row) {
      this.typeDialogType = type
      if (type === 1) {
        this.typeForm = {
          id: '',
          type: 0,
          name: '',
          showId: '',
          newStatus: 0,
          sortOrder: 0,
          displayStatus: 1,
          svipLevel: 0
        }
      } else {
        this.typeForm = {
          ...row,
          showId: row.showId || ''
        }
      }
      this.typeDialogVisible = true
    },
    handleTypeDialogClose() {
      this.typeForm = {
        id: '',
        type: 0,
        name: '',
        showId: '',
        newStatus: 0,
        sortOrder: 0,
        displayStatus: 1,
        svipLevel: 0
      }
      this.typeDialogVisible = false
    },
    async submitTypeForm() {
      let url
      if (this.typeDialogType === 1) {
        url = this.$store.getters.path.premium_id_type_add
      } else {
        url = this.$store.getters.path.premium_id_type_update
      }
      this.submitTypeLoading = true
      const { data: res } = await this.$axios.post(
        url +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        this.typeForm
      )
      this.submitTypeLoading = false
      if (res.code !== 0) return this.$message.error(res.msg)
      this.$message.success('操作成功')
      this.handleTypeDialogClose()
      this.queryType()
    },
    async toggleDisplayStatus(row) {
      const newStatus = row.displayStatus === 1 ? 0 : 1
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.premium_id_type_display_status +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        {
          id: row.id,
          displayStatus: newStatus
        }
      )
      if (res.code !== 0) return this.$message.error(res.msg)
      this.$message.success('操作成功')
      this.queryType()
    },

    // ============ 商品配置管理相关方法 ============
    async queryConfig() {
      this.configLoading = true
      const params = {
        ...this.configSearch,
        page: this.configPageInfo.page,
        pageSize: this.configPageInfo.pageSize
      }
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === '') {
          delete params[key]
        }
      })
      const { data: res } = await this.$axios.get(
        this.$store.getters.path.premium_id_config_list +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        {
          params
        }
      )
      this.configLoading = false
      if (res.code !== 0) return this.$message.error(res.msg)
      this.configList = res.data.data || []
      this.configPageInfo.total = res.data.total || 0
    },
    handleConfigPageChange(page) {
      this.configPageInfo.page = page
      this.queryConfig()
    },
    resetConfigSearch() {
      this.configSearch = {
        typeId: null,
        idLength: null,
        valid: null
      }
      this.configPageInfo.page = 1
      this.queryConfig()
    },
    operateConfig(type, row) {
      this.configDialogType = type
      if (type === 1) {
        this.configForm = {
          id: '',
          typeId: null,
          idLength: 5,
          valid: 1,
          specificationObjList: [{ points: 0, days: 0 }]
        }
      } else {
        this.configForm = {
          id: row.id,
          typeId: row.typeId,
          idLength: row.idLength,
          valid: row.valid,
          specificationObjList: row.specificationObjList && row.specificationObjList.length > 0
            ? [...row.specificationObjList]
            : [{ points: 0, days: 0 }]
        }
      }
      this.configDialogVisible = true
    },
    handleConfigDialogClose() {
      this.configForm = {
        id: '',
        typeId: null,
        idLength: 5,
        valid: 1,
        specificationObjList: [{ points: 0, days: 0 }]
      }
      this.configDialogVisible = false
    },
    addSpec() {
      this.configForm.specificationObjList.push({ points: 0, days: 0 })
    },
    removeSpec(index) {
      this.configForm.specificationObjList.splice(index, 1)
    },
    async submitConfigForm() {
      if (!this.configForm.typeId) {
        return this.$message.warning('请选择类型')
      }
      let url
      if (this.configDialogType === 1) {
        url = this.$store.getters.path.premium_id_config_add
        delete this.configForm.id
      } else {
        url = this.$store.getters.path.premium_id_config_update
      }
      // 确保specificationObjList有效
      if (!this.configForm.specificationObjList || this.configForm.specificationObjList.length === 0) {
        return this.$message.warning('请至少添加一条规格配置')
      }
      this.submitConfigLoading = true
      const { data: res } = await this.$axios.post(
        url +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        this.configForm
      )
      this.submitConfigLoading = false
      if (res.code !== 0) return this.$message.error(res.msg)
      this.$message.success('操作成功')
      this.handleConfigDialogClose()
      this.queryConfig()
    }
  }
}
</script>

<style scoped lang="scss">
.search {
  display: flex;
  > * {
    margin: 0 5px;
  }
  .el-input {
    width: 300px;
  }
}
.cell {
  display: flex;
  > * {
    margin: 2px;
  }
}
.item {
  display: flex;
  align-items: center;
  padding: 5px 0;
  span {
    white-space: nowrap;
    padding: 0 5px;
    // width: 100px;
  }
}
.spec-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 4px;
}
.spec-label {
  color: #909399;
  font-size: 13px;
  white-space: nowrap;
}
.spec-divider {
  margin: 0 2px;
  color: #c0c4cc;
}
.card {
  margin: 20px 0;
}
.title-biaoti {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
